import { createFileRoute } from '@tanstack/react-router';
import { AdminUserList } from '@/components/admin/admin-user-list';

export const Route = createFileRoute('/admin/users/')({
  component: AdminUserList,
});
